import template from './events_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EventsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EventsHelpPage
{
	constructor (bindings) {
		this.viewModel = new EventsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EventsHelp',
	dialog_class: EventsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/events_help',
	provider: 'ps'
};
